import React from 'react';

import {
  MoveInDateOptionsKeys,
  MoveOutDateOptionsKeys,
  MoveInDateOptions,
  MoveOutDateOptions,
} from 'common/constants/price-calc-display';

export function getMoveCategory(direction, moveType) {
  if (
    [
      MoveInDateOptionsKeys.EARLIER_THAN,
      MoveOutDateOptionsKeys.LATER_THAN,
      MoveInDateOptionsKeys.NO_LIMIT,
      MoveInDateOptionsKeys.RANGE,
    ].includes(moveType)
  ) {
    if (direction === 'moveIn') {
      return 'Move in: Charge the remaining days as a full month';
    } else {
      return 'Move out: Charge the remaining days as a full month';
    }
  } else {
    if (direction === 'moveIn') {
      return 'Move in: Charge the remaining days as actual days';
    } else {
      return 'Move out: Charge the remaining days as actual days';
    }
  }
}

export function getMoveType(direction, moveType) {
  switch (moveType) {
    case MoveInDateOptionsKeys.EARLIER_THAN:
      return 'Move in earlier than the selected date';
    case MoveOutDateOptionsKeys.LATER_THAN:
      return 'Move out later than the selected date';
    case MoveInDateOptionsKeys.RANGE:
      return direction === 'moveIn'
        ? 'Move in within a date range'
        : 'Move out within a date range';
    case MoveInDateOptionsKeys.NO_LIMIT:
      return direction === 'moveIn' ? 'Move in no limit' : 'Move out no limit';
    case MoveInDateOptionsKeys.ACTUAL_DAYS:
      return direction === 'moveIn'
        ? MoveInDateOptions.ACTUAL_DAYS
        : MoveOutDateOptions.ACTUAL_DAYS;
  }
}

export function getMoveDate(moveType, start, end) {
  if (moveType === MoveInDateOptionsKeys.EARLIER_THAN) {
    return <span className="price-calc-display__info-tag">{getDayWithSuffix(end)}</span>;
  }

  if (moveType === MoveOutDateOptionsKeys.LATER_THAN) {
    return <span className="price-calc-display__info-tag">{getDayWithSuffix(start)}</span>;
  }

  if ([MoveInDateOptionsKeys.RANGE, MoveOutDateOptionsKeys.RANGE].includes(moveType)) {
    return (
      <span className="price-calc-display__info-tag">{`${getDayWithSuffix(
        start,
      )}-${getDayWithSuffix(end)}`}</span>
    );
  }

  return null;
}

function getDayWithSuffix(day) {
  if (typeof day !== 'number' || day < 1 || day > 31) {
    throw new Error('Invalid day: must be a number between 1 and 31.');
  }

  const j = day % 10,
    k = day % 100;
  if (j == 1 && k != 11) {
    return day + 'st';
  }
  if (j == 2 && k != 12) {
    return day + 'nd';
  }
  if (j == 3 && k != 13) {
    return day + 'rd';
  }
  return day + 'th';
}
